var map = {
	"./animation.js": [
		6768,
		461
	],
	"./background.js": [
		1588,
		741
	],
	"./character.js": [
		2941,
		452
	],
	"./choice.js": [
		2015,
		90
	],
	"./dialog.js": [
		5500,
		17
	],
	"./effects.js": [
		9996,
		949
	],
	"./if_test.js": [
		4198,
		39
	],
	"./overflow-test.js": [
		335,
		254
	],
	"./resource-error-test.js": [
		5016,
		441
	],
	"./save-load-test.js": [
		3251,
		898
	],
	"./sound.js": [
		8605,
		864
	],
	"./test_error.js": [
		9433,
		372
	],
	"./text.js": [
		3315,
		98
	],
	"./title.js": [
		656,
		681
	],
	"./trigger-test.js": [
		9707,
		14
	],
	"./weather.js": [
		9582,
		899
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4654;
module.exports = webpackAsyncContext;